package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.TableMember
import fr.manyverse.app.domain.repository.GameTableRepository
import kotlinx.coroutines.flow.Flow

class ObserveGameTableMembersUseCase(
    private val gameTableRepository: GameTableRepository
) {
    operator fun invoke(tableId: String): Flow<List<TableMember>> {
        return gameTableRepository.observeTableMembers(tableId)
    }
}
